import { v4 as uuidv4 } from "uuid";

export const accessToken = () => {
  let token = "";
  if (typeof window !== "undefined") {
    if (
      localStorage.getItem("kcAccessToken") &&
      localStorage.getItem("kcTokenSaved")
    ) {
      let saved = localStorage.getItem("kcTokenSaved");
      if (localStorage.getItem("shortTimeUser")) {
        if (saved && new Date().getTime() - saved < 9000000) {
          token = localStorage.getItem("kcAccessToken");
          return token;
        } else {
          localStorage.removeItem("kcTokenSaved");
          localStorage.removeItem("longTimeUser");
          localStorage.removeItem("shortTimeUser");
          localStorage.removeItem("kcAccessToken");
          localStorage.removeItem("kcRefreshToken");
          localStorage.removeItem("rValidity");
          localStorage.removeItem("aValidity");
          return null;
        }
      } else {
        let rTime = localStorage.getItem("rValidity");
        if (new Date().getTime() - saved < rTime * 1000) {
          if (saved && new Date().getTime() - saved < 9000000) {
            token = localStorage.getItem("kcAccessToken");
            return token;
          } else {
            const url =
              process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
              `/profile/v1/identity/users/token`;
            let rToken = localStorage.getItem("kcRefreshToken");
            let data = {
              clientId: process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_CLIENT_ID,
              realm: process.env.NEXT_PUBLIC_REACT_APP_KEYCLOAK_REALM,
              tokenType: "refresh",
              refreshToken: rToken,
            };

            fetch(url, {
              method: "POST",
              body: JSON.stringify(data),
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                "trace-id": uuidv4(),
              },
            })
              .then((res) => {
                if (res.ok) {
                  return res.json();
                } else {
                  throw res;
                }
              })
              .then((resp) => {
                if (localStorage.getItem("kcRefreshToken")) {
                  localStorage.removeItem("kcAccessToken");
                  localStorage.removeItem("kcRefreshToken");
                  localStorage.removeItem("rValidity");
                  localStorage.removeItem("aValidity");
                  localStorage.removeItem("kcTokenSaved");
                }
                localStorage.setItem("kcTokenSaved", new Date().getTime());
                localStorage.setItem("kcAccessToken", resp.access_token);
                localStorage.setItem("kcRefreshToken", resp.refresh_token);
                localStorage.setItem("rValidity", resp.refresh_expires_in);
                localStorage.setItem("aValidity", resp.expires_in);
                return resp.access_token;
              })
              .catch((res) => {
                return null;
              });
            // const reloadUsingLocationHash = () => {
            //   window.location.hash = "reload";
            // }
            // window.onload = reloadUsingLocationHash();
          }
        } else {
          localStorage.removeItem("kcTokenSaved");
          localStorage.removeItem("longTimeUser");
          localStorage.removeItem("shortTimeUser");
          localStorage.removeItem("kcAccessToken");
          localStorage.removeItem("kcRefreshToken");
          localStorage.removeItem("rValidity");
          localStorage.removeItem("aValidity");
          return null;
        }
      }
    } else {
      // return {'status' : 'guest'}
      return process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN;
    }
  }
};
